import {
	ArrowLeftIcon,
	ArrowsClockwiseIcon,
	WarningCircleIcon,
} from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import {
	isRouteErrorResponse,
	useNavigate,
	useRouteError,
} from "react-router-dom";

import { Button } from "@/components/ui/button";

export default function RouteError() {
	const { t } = useTranslation();
	const error = useRouteError();
	const navigate = useNavigate();

	const isNotFound = isRouteErrorResponse(error) && error.status === 404;
	const title = isNotFound
		? t("errorPage.pageNotFound")
		: t("errorPage.somethingWentWrong");
	const defaultMessage = t("errorPage.anExpectedErrorOccurred");
	const message = isNotFound
		? t("errorPage.pageDoesNotExist")
		: isRouteErrorResponse(error)
			? error.statusText || error.data?.message || defaultMessage
			: (error instanceof Error && error.message) || defaultMessage;

	return (
		<div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-gray-50 px-6">
			<div className="flex max-w-md flex-col items-center gap-4 text-center">
				<div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-100 text-red-600">
					<WarningCircleIcon className="h-7 w-7" aria-hidden />
				</div>
				<h1 className="font-semibold text-heading-1 text-xl">{title}</h1>
				<p className="text-sm text-text-1">{message}</p>
			</div>
			<div className="flex flex-wrap items-center justify-center gap-3">
				<Button
					variant="outline"
					className="rounded-lg border-cyan-600 bg-cyan-50 text-cyan-700 hover:bg-cyan-100"
					onClick={() => navigate(-1)}
				>
					<ArrowLeftIcon className="mr-2 h-4 w-4" />
					{t("errorPage.goBack")}
				</Button>
				<Button
					className="rounded-lg bg-cyan-700 text-white hover:bg-cyan-800"
					onClick={() => window.location.reload()}
				>
					<ArrowsClockwiseIcon className="mr-2 h-4 w-4" />
					{t("errorPage.tryAgain")}
				</Button>
			</div>
		</div>
	);
}
